<template>
    <div id="contact" class="py-12 text-white bg-indigo-500">
        <div class="mx-auto w-10/12 lg:w-9/12">
            <h1 class="text-xl font-medium tracking-widest">Get in touch_</h1>
            <div class="flex flex-col md:flex-row mt-5 gap-12 lg:gap-24 w-full">
                <div class="w-full md:w-6/12 lg:w-auto">
                    <div class="flex gap-4 mb-1">
                        <span>PHONE :</span>
                        <span>+91 8638886083</span>
                    </div>
                    <div class="flex gap-4 mb-1">
                        <span>EMAIL :</span>
                        <span>debarshi121@gmail.com</span>
                    </div>
                     <div class="flex gap-4 mb-1">
                        <span>SKYPE :</span>
                        <span>debarshi121</span>
                    </div>
                    <div class="flex gap-6 mt-4 cursor-pointer">
                        <a href="https://www.facebook.com/debarshi121" class="flex items-center cursor-pointer">
                            <svg xmlns="http://www.w3.org/2000/svg" class="w-4 mr-1" fill="white" viewBox="0 0 24 24"><path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm3 8h-1.35c-.538 0-.65.221-.65.778v1.222h2l-.209 2h-1.791v7h-3v-7h-2v-2h2v-2.308c0-1.769.931-2.692 3.029-2.692h1.971v3z"/></svg>
                            Facebook
                        </a>
                        <a href="https://www.linkedin.com/in/debarshi-das/" class="flex items-center cursor-pointer">
                            <svg xmlns="http://www.w3.org/2000/svg" class="w-4 mr-1" fill="white" viewBox="0 0 24 24"><path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-2 16h-2v-6h2v6zm-1-6.891c-.607 0-1.1-.496-1.1-1.109 0-.612.492-1.109 1.1-1.109s1.1.497 1.1 1.109c0 .613-.493 1.109-1.1 1.109zm8 6.891h-1.998v-2.861c0-1.881-2.002-1.722-2.002 0v2.861h-2v-6h2v1.093c.872-1.616 4-1.736 4 1.548v3.359z"/></svg>
                            Linkedin
                        </a>
                    </div>
                </div>
                <div class="w-full md:w-6/12 lg:w-4/12">
                    <div class="mb-4">Or just write me a message here..</div>
                    <input type="text" v-model="name" placeholder="Your name" class="mb-2 placeholder-indigo-300 focus:outline-none placeholder-gray-200 w-full block text-white px-2 py-1 border rounded border-white bg-transparent">
                    <input type="text" v-model="email" placeholder="Your email" class="mb-2 placeholder-indigo-300 focus:outline-none placeholder-gray-200 w-full block text-white px-2 py-1 border rounded border-white bg-transparent">
                    <textarea placeholder="Your message" v-model="message" class="mb-2 w-full placeholder-indigo-300 focus:outline-none placeholder-gray-200 block text-white px-2 py-1 border rounded border-white bg-transparent"> </textarea>
                    <button @click="sendMail" class="flex items-center justify-center focus:outline-none border-2 border-gray-200 rounded-full font-medium text-gray-200 px-8 py-1 text-sm transition duration-300 ease-in-out hover:bg-indigo-600 hover:text-white mr-6">
                        <svg v-if="isSending" class="animate-spin mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        SEND
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
export default {
    data: function() {
        return {
            name: '',
            email: '',
            message: '',
            isSending: false
        }
    },
    methods: {
        async sendMail(){
            if(this.name.trim() && this.email.trim() && this.message.trim()){
                this.isSending = true
                const response = await axios.post("https://portfolio-debarshi-api.herokuapp.com/api/v1/mail", {
                    name: this.name,
                    email: this.email,
                    message: this.message,
                });
                if(response.status==200){
                    this.name = ''
                    this.email = ''
                    this.message = ''
                    this.$toaster.success('Your message has been sent.')
                    this.isSending = false
                } else{
                    this.$toaster.error('Your inputs are invalid.')
                    this.isSending = false
                }
                this.isSending = false
            }
        }
    },
}
</script>